import React from "react";
import Hero from "./components/Hero";
import About from "./components/About";
// import Clients from "./components/Clients";
import CallToAction from "./components/CallToAction";
import OnfocusSection from "./components/OnfocusSection";
import FeaturesSection from "./components/FeaturesSection";
import ServicesSection from "./components/ServicesSection";
import FaqSection from "./components/FaqSection";
import PortfolioSection from "./components/PortfolioSection";
import RecentPostsSection from "./components/RecentPostsSection";
import TestimonialsSection from "./components/TestimonialsSection";

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      {/* <Clients /> */}
      <CallToAction />
      <OnfocusSection />
      <FeaturesSection />
      <ServicesSection />
      <TestimonialsSection />
      <PortfolioSection />
      <RecentPostsSection />
      <FaqSection />
    </>
  );
};

export default Home;
